import { AuthCallbackScreen } from "@/screens/auth-callback/auth-callback-screen";

export function AuthCallbackPage() {
  return <AuthCallbackScreen />;
}
